import { createI18n, PluralizationRule, PluralizationRulesMap } from 'vue-i18n';
import config from '~/plugins/config';
import cs from './locales/cs.json';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import pl from './locales/pl.json';
import nl from './locales/nl.json';

import deValidation from './locales/validation/zod.de.json';
import enValidation from './locales/validation/zod.en.json';
import csValidation from './locales/validation/zod.cs.json';
import frValidation from './locales/validation/zod.fr.json';
import plValidation from './locales/validation/zod.pl.json';
import nlValidation from './locales/validation/zod.pl.json';
import deEnums from './locales/enums/de.json';
import enEnums from './locales/enums/en.json';
import csEnums from './locales/enums/cs.json';
import frEnums from './locales/enums/fr.json';
import plEnums from './locales/enums/pl.json';
import nlEnums from './locales/enums/nl.json';
const _createI18n = () => {
    const { locale, fallbackLocale } = config.app;

    const createPluralizationMap = (): PluralizationRulesMap => ({
        cs: (choice: number, choicesLength: number, orgRule?: PluralizationRule): number => {
            if (choice === 0) return choicesLength === 4 ? 0 : choicesLength - 1;
            if (choice === 1) return choicesLength - 3;
            if (choice > 1 && choice <= 4) return choicesLength - 2;
            if (choice > 4) return choicesLength - 1;

            return orgRule ? orgRule(choice, choicesLength) : 0;
        },
    });

    return createI18n({
        legacy: false,
        warnHtmlInMessage: false,
        globalInjection: true,
        locale,
        fallbackLocale,
        fallbackWarn: false,
        missingWarn: false,
        pluralRules: createPluralizationMap(),
        messages: {
            cs: {
                ...cs,
                enums: csEnums,
                validation: {
                    web: csValidation,
                },
            },
            en: {
                ...en,
                enums: enEnums,
                validation: {
                    web: enValidation,
                },
            },
            de: {
                ...de,
                enums: deEnums,
                validation: {
                    web: deValidation,
                },
            },
            fr: {
                ...fr,
                enums: frEnums,
                validation: {
                    web: frValidation,
                },
            },
            pl: {
                ...pl,
                enums: plEnums,
                validation: {
                    web: plValidation,
                },
            },
            nl: {
                ...nl,
                enums: nlEnums,
                validation: {
                    web: nlValidation,
                },
            },
        },
    });
};

export default _createI18n;
